import React from "react";
import RaiseYourVoiceComponent from "components/Project/ActiveProject/Step_3/RaiseYourVoice/RaiseYourVoiceComponent";
import AxiosConfig from "axiosConfig";
import imageCompression from "browser-image-compression";
import { validImages } from '../../../../../components/Spotlight/Album/ValidFiles';

/**
 * @description Saves and fetches all the information of the Challenge 3 Raise your voice
 * @class RaiseYourVoice
 * @implements RaiseYourVoiceComponent
 * @extends React.Component
 * @type {RaiseYourVoice}
 * @example <RaiseYourVoice />
 * pre-condition: all the imports
 * post-condition: saves all the information of the Develop new habit page
 * @param null
 * @returns {RaiseYourVoice}
 */

class RaiseYourVoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newVoice: "",
      reflect_on_impact: "",
      file_upload: "",
      final_file_upload: "",
      projectSlug: this.props.location.state.projectSlug,
      projectBanner: "",
      errorMessage: "",
      challengeSlug: this.props.location.state.challengeSlug,
      hasVoice: true,
      hasReflectOnImpact: true,
      hasVideo: true,
      fileType: "",
      imagePopup: true,
      displayImagePopup: false,
      displayCustomPopup: false,
      displayCreationSuite: false,
      fileData: null,
      count: 1
    };
    this.openPopUp = this.openPopUp.bind(this);
    this.closePopUp = this.closePopUp.bind(this);
    this.popupControl = this.popupControl.bind(this);
    this.openCustomPopUp = this.openCustomPopUp.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
    this.uploadApi = this.uploadApi.bind(this);
    this.openCreationSuite = this.openCreationSuite.bind(this);
    this.closeCreationSuite = this.closeCreationSuite.bind(this);
    this.handleCreationSuiteUpload = this.handleCreationSuiteUpload.bind(this);
  }
  openPopUp() {
    this.setState({
      displayImagePopup: true,
      count: 1
    })
    this.popupControl();
  }

  closePopUp() {
    this.setState({
      displayImagePopup: false,
      displayCustomPopup: false
    })
  }
  openCreationSuite() {
    this.setState({
      displayCreationSuite: true
    })
  }

  closeCreationSuite() {
    this.setState({
      displayCreationSuite: false,
      displayImagePopup: false,
      displayCustomPopup: false,
      fileData: null
    })
  }
  uploadApi() {
    const file = this.state.fileData;
    let form_data = new FormData();
    form_data.append("media", file);
    form_data.append("username", '');
    form_data.append("file_type", file.type);
    form_data.append("media_type", this.readMediaType(file.name));
    form_data.append("user_access", 'P');
    form_data.append("media_source", 'U');
    form_data.append("belongs_in", 'A');
    let album_form = form_data;
    album_form.append("belongs_in", 'C');

    AxiosConfig.post('mediaManager/media/', album_form, {//HTPP POST Request
      headers: {
        "content-type": "multipart/form-data",
      },
    }).then(res => {
      this.setState({
        displayCreationSuite: true
      })
    }).catch(err => {
    });

  }
  getExtension(file) {
    let ext = "";
    ext = file.split('.').pop();
    return ext;
  }
  readMediaType(file) {
    let ext = "";
    ext = this.getExtension(file);
    if (validImages().indexOf(ext) > -1) {
      return 'I';
    }
    else {
      return "";
    }
  }
  handleCreationSuiteUpload(val) {
    if (val) {
      const file = val;
      const fileType = file.type;
      const fileSize = file.size / 1024;
      const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      // const videoSize = file.size / 1024 / 1024;
      // if (videoSize > 2) {
      //   this.setState({
      //     errorMessage: "Video is too big in size. Maximum 2MB is accepted",
      //   });
      // } else {
      if (fileType.includes("image")) {
        if (fileSize > 2000) {
          if (fileType.includes("gif")) {
            this.setState({
              video: "",
              userProjectVideo: "",
              errorMessage:
                "Uploaded photo is too big in size. Maximum 2MB accepted for GIFs.",
              fileType: "",
            });
          } else {
            imageCompression(file, options)
              .then((compressedFile) => {
                this.setState({
                  video: URL.createObjectURL(compressedFile),
                  userProjectVideo: compressedFile,
                  errorMessage: "",
                  fileType: "image",
                  imagePopup: false
                });
              })
              .catch((error) => { });
          }
        } else {
          this.setState({
            video: URL.createObjectURL(file),
            userProjectVideo: file,
            errorMessage: "",
            fileType: "image",
            imagePopup: false
          });
        }
      } else if (fileType.includes("video")) {
        this.setState({
          video: URL.createObjectURL(file),
          userProjectVideo: file,
          errorMessage: "",
          fileType: "video",
          imagePopup: false
        });
      } else {
        this.setState({
          video: "",
          userProjectVideo: "",
          errorMessage: "Please upload a video or photo.",
          fileType: "",
        });
      }
    }
  }

  fileUpload() {
    const file = this.state.fileData;
    const fileType = file.type;
    const fileSize = file.size / 1024;
    const options = {
      maxSizeMB: 2,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    if (fileSize > 2000) {
      if (fileType.includes("gif")) {
        this.setState({
          video: "",
          userProjectVideo: "",
          errorMessage:
            "Uploaded photo is too big in size. Maximum 2MB accepted for GIFs.",
          fileType: "",
        });
      } else {
        imageCompression(file, options)
          .then((compressedFile) => {
            this.setState({
              video: URL.createObjectURL(compressedFile),
              userProjectVideo: compressedFile,
              errorMessage: "",
              fileType: "image",
              imagePopup: false,
              displayCustomPopup: false,
              displayImagePopup: false
            });
          })
          .catch((error) => { });
      }
    } else {
      this.setState({
        video: URL.createObjectURL(file),
        userProjectVideo: file,
        errorMessage: "",
        fileType: "image",
        imagePopup: false,
        displayCustomPopup: false,
        displayImagePopup: false
      });
    }
  }
  popupControl() {
    this.setState({
      imagePopup: true
    })
  }
  openCustomPopUp(file) {
    this.setState({
      displayImagePopup: false,
      displayCustomPopup: true,
      fileData: file,
      count: 2,
    })
  }
  onBackButtonEvent = () => {
    this.props.history.push({
      pathname: `/projects/`,
    });
  };
  componentDidMount() {
    window.onpopstate = (e) => {
      this.onBackButtonEvent();
    };

    Promise.all([
      AxiosConfig.get("/impactprojects/active_project_list_new/"),
      AxiosConfig.get(
        `/impactprojects/raise_your_voice/?project=${this.state.projectSlug}&challenge=${this.props.location.state.challengeSlug}&projectUserId=${this.props.location.state.projectUserId}`
      ),
    ])
      .then(([res1, res2]) => {
        for (let i = 0; i < res1.data.length; i++) {
          if (res1.data[i].project.slug === this.state.projectSlug) {
            this.setState({
              projectBanner: res1.data[i].project.banner,
            });
          }
        }
        if (res2.data) {
          this.setState({
            newVoice: res2.data.new_voice,
            reflect_on_impact: res2.data.reflect_on_impact,
            file_upload: res2.data.file_upload,
          });
        }
      })
      .catch();
  }

  defaultIfEmpty(value) {
    return value === "" ? "" : value;
  }

  changeHandler = (event) => {
    let eventName = event.target.name;
    if (eventName === "newVoice") this.setState({ hasVoice: true });
    else if (eventName === "reflect_on_impact")
      this.setState({ hasReflectOnImpact: true });

    this.setState({
      // ...this.state,
      [event.target.name]: event.target.value,
    });
  };

  videoHandler(event) {
    if (event.target.files[0]) {
      const file = event.target.files[0];
      const fileType = file.type;
      const fileSize = file.size / 1024;
      const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      // const videoSize = event.target.files[0].size / 1024 / 1024;
      // if (videoSize > 2) {
      //   this.setState({
      //     hasVideo: false,
      //   });
      // } else {}
      if (fileType.includes("image")) {
        this.openCustomPopUp(file);
      } else if (fileType.includes("video")) {
        this.setState({
          file_upload: URL.createObjectURL(file),
          final_file_upload: file,
          hasVideo: true,
          fileType: "video",
          imagePopup: false
        });
      } else {
        // this.setState({
        //   file_upload: "",
        //   final_file_upload: "",
        //   hasVideo: false,
        //   fileType: "",
        // });
      }
    }
  }
  validateForm() {
    let valid = true;
    this.setState({
      hasVoice: true,
      hasReflectOnImpact: true,
      hasVideo: true,
    });
    if (!this.state.newVoice) {
      this.setState({ hasVoice: false });
      valid = false;
    }
    if (
      !this.state.reflect_on_impact ||
      this.state.reflect_on_impact === "null"
    ) {
      this.setState({ hasReflectOnImpact: false });
      valid = false;
    }
    if (!this.state.file_upload) {
      // this.setState({
      //   hasVideo: false,
      // });
      // valid = false;
    }
    return valid;
  }
  saveHandler(event, action_type) {
    event.preventDefault();
    let formData = new FormData();
    try {
      formData.append("new_voice", this.state.newVoice);
      formData.append("reflect_on_impact", this.state.reflect_on_impact);
      formData.append("projectUserId", this.props.location.state.projectUserId);
      if (this.state.final_file_upload) {
        formData.append(
          "file_upload",
          this.state.final_file_upload,
          this.state.final_file_upload.name
        );
      }
      if (this.state.fileData) {
        formData.append(
          "file_upload",
          this.state.fileData,
          this.state.fileData.name
        );
      }
      formData.append("project", this.state.projectSlug);
      formData.append("action_type", action_type);
      formData.append("challenge", this.props.location.state.challengeSlug);
    } catch (err) {}

    if (
      action_type.toString().toLowerCase() === "done" &&
      this.validateForm()
    ) {
      AxiosConfig.put("/impactprojects/raise_your_voice/", formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
        .then((res) => {
          this.props.history.push({
            pathname: `/projects/${this.state.projectSlug}/congratulations`,
            state: {
              adventureId: this.props.location.state.adventureId,
              adventureSlug: this.props.location.state.adventureSlug,
              challengeSlug: this.props.location.state.challengeSlug,
              video: res.data.file_upload,
              projectUserId: this.props.location.state.projectUserId,
            },
          });
        })
        .catch();
    } else if (
      action_type.toString().toLowerCase() === "save"
    ) {
      return AxiosConfig.put("impactprojects/raise_your_voice/", formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
        .then(this.props.history.push("/projects/"))
        .catch();
    }
  }

  render() {
    return (
      <RaiseYourVoiceComponent
        newVoice={this.state.newVoice}
        reflect_on_impact={this.state.reflect_on_impact}
        projectBanner={this.state.projectBanner}
        defaultIfEmpty={this.defaultIfEmpty.bind(this)}
        changeHandler={this.changeHandler.bind(this)}
        videoHandler={this.videoHandler.bind(this)}
        saveHandler={this.saveHandler.bind(this)}
        hasVoice={this.state.hasVoice}
        hasReflectOnImpact={this.state.hasReflectOnImpact}
        hasVideo={this.state.hasVideo}
        isInvite={this.props.location.state.isInvite}
        video={this.state.file_upload}
        challengeSlug={this.props.location.state.challengeSlug}
        goalDate={this.props.location.state.goalDate}
        adventureId={this.props.location.state.adventureId}
        projectSlug={this.props.location.state.projectSlug}
        adventureSlug={this.props.location.state.adventureSlug}
        email={this.props.location.state.email}
        invitationId={this.props.location.state.invitationId}
        projectUserId={this.props.location.state.projectUserId}
        showStepper={this.props.location.state.showStepper}
        fileData={this.state.fileData}
        count={this.state.count}
        closePopUp={this.closePopUp}
        openPopUp={this.openPopUp}
        openCreationSuite={this.openCreationSuite}
        closeCreationSuite={this.closeCreationSuite}
        displayImagePopup={this.state.displayImagePopup}
        displayCustomPopup={this.state.displayCustomPopup}
        displayCreationSuite={this.state.displayCreationSuite}
        uploadApi={this.uploadApi}
        fileType={this.state.fileType}
        fileUpload={this.fileUpload}
        imagePopup={this.state.imagePopup}
        popupControl={this.popupControl}
        handleCreationSuiteUpload={this.handleCreationSuiteUpload}
      />
    );
  }
}

export default RaiseYourVoice;
